module.exports = __webpack_public_path__ + "img/icon_map_2_c.bb25bcbe.png";